import React, { useEffect, useState } from 'react';

import { GoBellFill } from 'react-icons/go';
import { BiSolidBellRing } from 'react-icons/bi';
import ClickAwayListener from '@mui/core/ClickAwayListener';
import { useNotificationContext } from 'hooks/useNotifications';
import {
  Container,
  NotificationsBox,
  NotificationsBoxContainer,
  NotificationsContainer,
  NotificationsHeader,
  NotificationsIcon,
  NotificationText,
  Title,
  QuantityContainer,
  QuantityText,
  NotificationsItems,
} from './styles';
import NotificationItem from './NotificationItem';

const NewNotifications: React.FC = () => {
  const [showNotificationContainer, setShowNotificationContainer] =
    useState(false);
  const { quantityNotifications, notifications, loadNotifications } =
    useNotificationContext();

  useEffect(() => {
    loadNotifications();
  }, []);

  const hasNotification = quantityNotifications > 0;

  return (
    <Container onClick={() => setShowNotificationContainer((prev) => !prev)}>
      {hasNotification ? (
        <>
          <BiSolidBellRing color="#656565" size={30} />
          <NotificationsContainer>
            <NotificationText>{quantityNotifications}</NotificationText>
          </NotificationsContainer>
        </>
      ) : (
        <GoBellFill color="#656565" size={30} />
      )}
      {showNotificationContainer && hasNotification && (
        <ClickAwayListener
          onClickAway={() => setShowNotificationContainer(false)}
        >
          <NotificationsBox>
            <NotificationsIcon />
            <NotificationsBoxContainer>
              <NotificationsHeader>
                <Title>Notificações</Title>
                <QuantityContainer>
                  <QuantityText>{quantityNotifications}</QuantityText>
                </QuantityContainer>
              </NotificationsHeader>
              <NotificationsItems>
                {hasNotification &&
                  notifications.map((notification, idx) => (
                    <NotificationItem
                      data={notification}
                      lastData={quantityNotifications - 1 === idx}
                    />
                  ))}
              </NotificationsItems>
            </NotificationsBoxContainer>
          </NotificationsBox>
        </ClickAwayListener>
      )}
    </Container>
  );
};

export default NewNotifications;
